import {
  customInstance
} from "./chunk-PXAHF6KP.js";

// generated/search-bff/controllers/master-data/master-data.ts
var getShops = (masterDataListRequest, options) => {
  return customInstance(
    {
      url: `/api/v1/masterdata/shop`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: masterDataListRequest
    },
    options
  );
};
var getShop = (idOrShortId, options) => {
  return customInstance(
    {
      url: `/api/v1/masterdata/shop/${idOrShortId}`,
      method: "GET"
    },
    options
  );
};

export {
  getShops,
  getShop
};
